import './App.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import InstallForm from '../Pages/Install';
import Home from '../Pages/Home';
import Users from '../Pages/Users';
import LoginForm from '../Pages/Login';
import SetPasswordPage from '../Pages/SetPassword';
import UserProfile from '../Pages/UserProfile';
import Settings from '../Pages/Settings';
import Locations from '../Pages/Locations';
import Clients from '../Pages/Clients';
import Packages from '../Pages/Packages';
import ClientDetail from '../Pages/ClientDetail';
import Availability from '../Pages/Availability';
import ClientSchedule from '../Pages/ClientSchedule';
import Pay from '../Pages/Pay';
import ConfirmEmailPage from '../Pages/ConfirmEmail';
import { AuthProvider } from '../Components/AuthContext';
function App() {
  return (
    <AuthProvider>
    <Router>
      <Routes>
        {/* Redirect root to install for testing */}
        <Route path="/" element={<Navigate to="install" />} />
        
        {/* Install route */}
        <Route path="/install" element={<InstallForm />} />
        <Route path="/set-password" element={<SetPasswordPage />} />
        <Route path="/confirm-email" element={<ConfirmEmailPage />} />
        <Route path="/:tenantDomain/login" element={<LoginForm />} />
        <Route path="/:tenantDomain/home" element={<Home />} />
        <Route path="/:tenantDomain/users" element={<Users />} />
        <Route path="/:tenantDomain/user/:userId" element={<UserProfile />} />
        <Route path="/:tenantDomain/settings" element={<Settings />} />
        <Route path="/:tenantDomain/locations" element={<Locations />} />
        <Route path="/:tenantDomain/clients" element={<Clients />} />
        <Route path="/:tenantDomain/clients/:clientId" element={<ClientDetail />} />
        <Route path="/:tenantDomain/packages" element={<Packages />} />
        <Route path="/:tenantDomain/availability" element={<Availability />} />
        <Route path="/:tenantDomain/book" element={<ClientSchedule />} />
        <Route path="/:tenantDomain/pay/:invoiceId" element={<Pay />} />
        {/* Catch all other routes */}
        <Route path="*" element={<div>Page not found</div>} />
      </Routes>
    </Router>
    </AuthProvider> 
  );
}

export default App;
